import { useEffect, useState, useRef } from 'react';

const getDefaultWidth = ref => (ref.current ? ref.current.offsetWidth : 0);

const useResizeWidthObserver = (resizeRef, refresh?): number => {
    const [width, setWidth] = useState(getDefaultWidth(resizeRef));
    const resizeObserver = useRef(null);

    useEffect(() => {
        if (resizeRef && resizeRef.current && 'ResizeObserver' in window) {
            observe(ResizeObserver);
        }
        function observe(RO) {
            resizeObserver.current = new RO(entries => {
                window.requestAnimationFrame(() => {
                    if (!Array.isArray(entries) || !entries.length) {
                        return;
                    }
                    const contentWidth = entries[0].contentRect.width;
                    setWidth(contentWidth);
                });
            });
            resizeObserver.current.observe(resizeRef.current);
        }

        return disconnect;
    }, [resizeRef]);

    useEffect(() => {
        refresh && resizeRef?.current && setWidth(resizeRef.current.offsetWidth);
    }, [resizeRef, refresh]);

    function disconnect() {
        if (resizeObserver.current) {
            resizeObserver.current.disconnect();
        }
    }

    return Math.round(width);
};

export default useResizeWidthObserver;
